import { Condition } from "@redotech/redo-model/return-flow/condition";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export type OrderlessState = void;

export const ORDERLESS = (
  Details: React.ComponentType<ConditionTypeDetailsProps<OrderlessState>>,
): ConditionType<OrderlessState, Condition.Orderless> => ({
  name: "Orderless",
  description() {
    return "No order associated with the request";
  },
  Details(props: ConditionTypeDetailsProps<OrderlessState>) {
    return React.createElement(Details, props);
  },
  empty: undefined,
  fromModel() {},
  toModel() {
    return { type: Condition.ORDERLESS };
  },
  valid() {
    return true;
  },
});
